import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import PartnerHeroSection from './components/PartnerHeroSection';
import PartnerServiceSection from './components/PartnerServiceSection';
import FlowSection from './components/FlowSection';
import PartnerCTASection from './components/PartnerCTASection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const partnerJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  url: `${SITE_URL}/partner`,
  name: '東京シニア婚活パートナー探し・マッチング | 縁結び 和はは',
  description: '東京のシニア婚活相談所「縁結び和はは」のパートナー探しサービス。50代・60代・70代の方に寄り添った丁寧なシニア婚活マッチングサポートを提供。東京のシニア婚活の出会いをバックアップします。',
  about: {
    '@type': 'Thing',
    name: 'シニア婚活パートナー探し',
    description: '東京の50代・60代・70代向けシニア婚活マッチングサービス',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'パートナー探し', item: `${SITE_URL}/partner` },
    ],
  },
};

export default function PartnerPage() {
  return (
    <>
      <SeoHead
        title="パートナー探し・マッチング | 縁結び 和はは 東京シニア婚活"
        description="東京のシニア婚活相談所「縁結び和はは」のパートナー探しサービス。50代・60代・70代の婚活に最適な出会いをご提供。丁寧なカウンセリングと本格的なシニア婚活マッチングで幸せな出会いを実現。"
        keywords="東京 シニア 婚活, シニアパートナー探し 東京, 婚活マッチング東京, 50代出会い, 60代再婚, 70代婚活パートナー探し"
        path="/partner"
        jsonLd={partnerJsonLd}
      />
      <Navbar />
      <main>
        <PartnerHeroSection />
        <PartnerServiceSection />
        <FlowSection />
        <PartnerCTASection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
